import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu', 'menuTrigger', 'submenu'];

  hideUserMenus = ({ target }) => {
    if (this.#isWindow(target) || !this.#isMenuOrTrigger(target)) {
      this.menuTarget.classList.add('invisible');
      this.submenuTarget.classList.add('invisible');
    }
  }

  #isMenuOrTrigger = target => this.menuTarget.contains(target)
    || this.menuTriggerTarget.isEqualNode(target)

  #isWindow = (target) => {
    if (typeof window.constructor !== 'undefined') {
      return target instanceof window.constructor;
    }
    return target.window === target;
  }

  showTarget = ({ params: { showTarget } }) => {
    const elem = this[`${showTarget}Target`];
    if (elem.classList.contains('invisible')) {
      elem.classList.remove('invisible');
    }
  }

  toggleVisibility = ({ params: { toggleTarget } }) => {
    const elem = this[`${toggleTarget}Target`];
    elem.classList.toggle('invisible');
  }
}
